export const addProjectListClickEvent = (e, _this) => {
    const $eTarget = $(e.target);

    /*프로젝트 아이템 */
    if ($eTarget.closest('.js-prj-item').length > 0) {
        AllProject.clickProjectItems(e)
    }

    /*새로운 프로젝트 아이템 */
    if ($eTarget.closest('.js-new-prj').length > 0) {
        if (Often.null2Void(LocalUtil.getLocalValue("ONLY_BUY_SETTING", "PRJ_MK_LMT_YN")) === 'O1') {
            Often.toast("error", i18next.t(common.contactAdmin));
            return;
        } else {
            const isProjectMakePro = Often.isFunc(Func.CLOUD.PROJECT_MAKE_PRO); // 프로젝트 2.0 및 프로젝트 템플릿 기능키
            isProjectMakePro ? ProjectMaker.openView() : ProjectMake.openPopup(e);
            return;
        }
    }
}
